import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';
import React from 'react';

const Body2Typography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, children, truncate = true }, ref) => (
		<h4
			ref={ref}
			className={cn(className, `scroll-m-20 text-sm font-medium ${truncate ? 'truncate' : ''}`)}
			data-testid={`body2-typography-${children?.toString().toLowerCase().slice(0, 10).replace(/\s+/g, '-')}`}
		>
			{children}
		</h4>
	)
);

Body2Typography.displayName = 'Body2Typography';

export default Body2Typography;
